import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { TopbarTitleComponent } from '@/layout/topbar/components/topbar-title/topbar-title.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { TopbarActionsComponent } from '@/layout/topbar/components/topbar-actions/topbar-actions.component';
import { OfferStore } from '@/features/offer/offer-store.service';

@Component({
  selector: 'app-topbar',
  imports: [TopbarTitleComponent, TranslocoPipe, TopbarActionsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './topbar.component.scss',
  templateUrl: './topbar.component.html',
})
export class TopbarComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  protected offerStore = inject(OfferStore);

  private navigationEnd = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      }),
    ),
  );

  protected topbarTitle = computed(() => this.navigationEnd()?.['topbar'] as { icon: string; label: string });

  protected onCreateOffer(): void {
    void this.offerStore.createOpportunity();
  }
}
